import { VideoObject } from 'schema-dts';
import { useAtomValue } from 'jotai';
import { $CurrentArticle } from '@article/shared/atoms/current-article';
import { ArticleDetailUtil, EArticleClass, IVideoArticleDetail } from 'shared/models';
import { useArticleAuthorJsonld } from '@article/head/json-ld/use-author-jsonld';
import { useTranslation } from 'react-i18next';
import { $Locale } from '@lemon8/web-app-shared/atom';
import { $CurrentArticleGPTInfo } from '../../shared/atoms/current-article-gpt-info';
import { $HitArticleGptTDK } from '~/utils/libra/article-gpt-tdk';

export const useVideoJsonLD = (): VideoObject | null => {
  const article = useAtomValue($CurrentArticle) as IVideoArticleDetail;
  const { t } = useTranslation();
  const { region } = useAtomValue($Locale);
  const authorJsonLd = useArticleAuthorJsonld();

  const gptInfo = useAtomValue($CurrentArticleGPTInfo);
  const hitArticleGptTDK = useAtomValue($HitArticleGptTDK);

  const abInfo = { hitArticleGptTDK };

  if (!ArticleDetailUtil.isArticleAvailable(article) || article.articleClass !== EArticleClass.VIDEO) {
    return null;
  }

  const videoObject = ArticleDetailUtil.JsonLD.getVideoObjectJsonLD({ article, region, t, abInfo, gptInfo });
  if (authorJsonLd) {
    videoObject.creator = authorJsonLd;
  }

  return videoObject;
};
